import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import cjs from '../../../node_modules/react-draggable/build/cjs/cjs.js';
import { styled } from '@mui/material';
import { createComponentSlot } from '../../../modules/styling/theme.js';

var _excluded = ["className", "sx", "children"];
var componentDraggableHeader = createComponentSlot({
  name: "CinModal",
  slot: "DraggableHeader"
});

var ModalDraggableHeaderBase = function ModalDraggableHeaderBase(_ref) {
  var className = _ref.className;
      _ref.sx;
      var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(cjs, _extends({
    bounds: "parent",
    handle: ".MuiDialogTitle-root",
    onStart: function onStart(e) {
      // ensure when using nested modals that only the top-most is moved
      e.stopPropagation();
    }
  }, props, {
    defaultClassName: classnames(componentDraggableHeader.className, className)
  }), children);
};

ModalDraggableHeaderBase.propTypes = {
  className: propTypes.string,
  sx: propTypes.any
};
var ModalDraggableHeaderRoot = styled(ModalDraggableHeaderBase, _objectSpread2(_objectSpread2({}, componentDraggableHeader.styledOptions), {}, {
  skipVariantsResolver: true
}))({
  ".MuiDialogTitle-root": {
    cursor: "move"
  }
});
/**
 * Allows a modal to be moved around by dragging its header
 */

var ModalDraggableHeader = function ModalDraggableHeader(props) {
  return /*#__PURE__*/React.createElement(ModalDraggableHeaderRoot, props);
};

ModalDraggableHeader.propTypes = {
  className: propTypes.string,
  sx: propTypes.any
};
var ModalDraggableHeader$1 = ModalDraggableHeader;

export { ModalDraggableHeader$1 as default };
